import { Card } from '@weezevent/nacre';
import { React, observer, main, useCallback, useMemo, useTranslation } from '..';

const Step = observer(({ child, index, steps }) => {
    const { t } = useTranslation();
    const step = index + 1;
    const title = `${step} - ${child?.props?.title}`;
    const nextsubtitle = `${child?.props?.inactive}`;
    const stepState = Object.values(steps)[index];
    const subtitle = stepState !== 'done' ? `${child?.props?.subtitle}` : nextsubtitle;
    const handleSetSelf = () => main.setStep(step);

    return (
        <Card.FormStep
            editLabel={t('ticket.common.action.edit')}
            title={title}
            subtitle={child?.props?.subtitle}
            summary={subtitle}
            onCardEdit={handleSetSelf}
            state={stepState}
            useSteps={true}
        >
            {child}
        </Card.FormStep>
    );
});

const Stepper = observer(({ children }) => {
    const { t } = useTranslation();
    const steps = useMemo(() => {
        let output = {};
        children.forEach((child, index) => {
            const step = index + 1;
            main.step === step ? (output[index] = 'open') : step < main.step ? (output[index] = 'done') : (output[index] = 'closed');
        });

        return output;
    }, [children, main.step]);

    const handleChange = useCallback(() => {
        Object.values(steps)[0] === 'done' ? main.setStep(main.step) : main.setStep(main.step - 1);
    }, [main, steps]);

    return (
        <Card.FormManager
            withStepsMobile
            useSteps
            steps={steps}
            onChangeSteps={() => handleChange()}
            labelPreviousStepMobile={t(['ticket.common.back_step'])}
            labelStepMobile={t(['ticket.common.step'])}
        >
            {React.Children.toArray(children).map((child, index) => (
                <Step key={child.id} child={child} index={index} steps={steps} />
            ))}
        </Card.FormManager>
    );
});

export default Stepper;
